import React from 'react';
import Box from '@mui/material/Box';
import { softFill } from '../styles';

// Segmented filter styled as pill controls — a soft track with a
// white "thumb" segment sliding under the active option, each with an optional
// count. Extracted from the Promotions page so any list page (drivers, users)
// can reuse the same control instead of re-deriving it.
const SegmentedFilter = ({ value, onChange, segments }) => (
  <Box sx={{ display: 'flex', p: '3px', borderRadius: '10px', backgroundColor: softFill }}>
    {segments.map((seg) => {
      const active = value === seg.key;
      return (
        <Box
          key={seg.key}
          component="button"
          type="button"
          onClick={() => onChange(seg.key)}
          sx={{
            flex: 1,
            border: 'none',
            cursor: 'pointer',
            height: '28px',
            borderRadius: '8px',
            fontSize: '12px',
            fontWeight: 600,
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
            transition: 'background-color 0.15s ease, color 0.15s ease',
            backgroundColor: active ? (theme) => theme.palette.background.paper : 'transparent',
            color: (theme) => (active ? theme.palette.text.primary : theme.palette.text.secondary),
            boxShadow: active ? '0 1px 2px rgba(0,0,0,0.12)' : 'none',
          }}
        >
          {seg.label}
          {seg.count != null && (
            <Box
              component="span"
              sx={{ color: (theme) => theme.palette.text.inactive, fontWeight: 500, fontSize: '11px' }}
            >
              {seg.count}
            </Box>
          )}
        </Box>
      );
    })}
  </Box>
);

export default SegmentedFilter;
